import { render, staticRenderFns } from "./Clases.vue?vue&type=template&id=3e1f6fbe&scoped=true"
import script from "./Clases.vue?vue&type=script&lang=js"
export * from "./Clases.vue?vue&type=script&lang=js"
import style0 from "./Clases.vue?vue&type=style&index=0&id=3e1f6fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1f6fbe",
  null
  
)

export default component.exports